var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":`${_vm.baseClass}--animated`,"appear":""},on:{"afterEnter":_vm.componentAfterEnter,"leave":_vm.componentLeave}},[_c('div',{class:`${_vm.baseClass}`},[_c('div',{ref:"component",class:`${_vm.baseClass}__component ${_vm.baseClass}__component--bubble-queries`})])])
}
var staticRenderFns = []

export { render, staticRenderFns }